import { Injectable } from '@angular/core';
import { ChartOptionsModel, ConsumptionQueryModel, FacilityListModel } from '@shared/models';
import { AsyncSubject, BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private readonly allFacilities$: AsyncSubject<FacilityListModel[]> = new AsyncSubject<FacilityListModel[]>();
  public readonly facilitiesList$: Observable<FacilityListModel[]>;
  private readonly preferences$: BehaviorSubject<any> = new BehaviorSubject<any>(JSON.parse(this.storageService.get('preferences')) || {});
  public csFilterParams$: BehaviorSubject<ConsumptionQueryModel> = new BehaviorSubject<ConsumptionQueryModel>(this.preferences?.filteringParams);

  /* tüketim özeti grafik işlemlerinde kullanılcak değişkenler */
  public chartOptions: ChartOptionsModel = {
    height: 365,
    duration: 360,
    top: 0,
    show: true,
    selectedIndex: 0,
    graphicShowing: (this.preferences?.filteringParams?.graphicShowing !== undefined)
      ? this.preferences?.filteringParams?.graphicShowing
      : true
  };

  constructor(private storageService: StorageService) {
    this.facilitiesList$ = this.allFacilities$.asObservable().pipe(distinctUntilChanged());
  }

  /**
   * tesisleri çekiyoruz.
   * @param facilities
   */
  setFacilities(facilities: FacilityListModel[]): void {
    this.allFacilities$.next(facilities);
    this.allFacilities$.complete();
  }

  /**
   * set preferences
   * @param key
   * @param val
   */
  setPreferences(key: string, val: string | boolean | number | object): void {
    this.storageService.setPreferences(key, val);
    this.preferences$.next(JSON.parse(this.storageService.get('preferences')));
  }

  /**
   * get preferences
   */
  get preferences(): any {
    return this.preferences$.value;
  }
}
